import { tryAxios } from '@/api/common/auth'
import { urlPrefix } from '@/configs/api'
import { UnitPositionMapData } from '@/api/common/mapData'

const apiUrl = `${urlPrefix}/CruiseList`
const GetList = `${apiUrl}`
const View = (id: number) => `${apiUrl}/view/${id}`
const Put = (id: number) => `${apiUrl}/${id}`
//日志统计数字
const GetLogReport = `${apiUrl}/logReport`
//日志列表
const GetLogList = `${apiUrl}/logList`
const Delete = (id: number) => `${apiUrl}/${id}`
//查询范围
// const GetLogLevels = `${apiUrl}/logLevels`
//巡查主体
// const GetTeamTypes = `${apiUrl}/teamTypes`

//#region jet代码
const GetNew = `${apiUrl}/newCruise`
const Post = `${apiUrl}/add`
const GetUnitPoints = (id: number) => `${apiUrl}/unit_points/${id}`

const ExportSummary = `${apiUrl}/exportSummary`//?h_np
//#endregion

//#region add by cc
export const emptyCruise: CruiseViewData = {
    Id: 0,
    CruiserId: 0,
    OfflineCruise: false,
    CruiseType: 0,
    CruiseDistance: 0,
    Comments: '',
    UpdateDate: new Date(),

    CruiseDate: new Date(),
    CruiserName: '',

    ListId: 0,
    UnitId: 0,
    UnitCode: '',
    UnitName: '',

    CruiseAttachTypePic: 0,
    CruiseAttachGuidPic: '',
    CruiseAttachTypeVideo: 0,
    CruiseAttachGuidVideo: '',

    CruisePointId: 0,
    CruisePointName: '',
    CruisePointLongitude: 0,
    CruisePointLatitude: 0,
    UnitPositionAreas: [],

    TrackId: 0,
    TrackDetails: []
}
export interface CruiseViewData {
    Id: number
    CruiserId: number
    OfflineCruise: boolean
    CruiseType: number
    CruiseDistance: number
    Comments: string
    UpdateDate: Date

    CruiseDate: Date
    CruiserName: string

    ListId: number
    UnitId: number
    UnitCode: string
    UnitName: string

    CruiseAttachTypePic: number
    CruiseAttachGuidPic: string
    CruiseAttachTypeVideo: number
    CruiseAttachGuidVideo: string

    CruisePointId: number
    CruisePointName: string
    CruisePointLongitude: number
    CruisePointLatitude: number
    UnitPositionAreas: UnitPositionMapData[]
    TrackId: number
    TrackDetails: any[]
}
// --1已巡查 2未巡查 3巡查计划 4事件 5计划外巡查 6计划外问题 7过期任务 8巡查轨迹
export interface CruiseLogSummary {
    //1已巡查
    CruiseCount: number
    //2未巡查
    UnCruiseCount: number
    //3巡查计划
    PlanCount: number
    //4事件
    EventCount: number
    //5计划外巡查
    CruiseNotInTask: number
    //6计划外问题
    EventNotInTask: number
    //7过期任务
    ExpiredTask: number
    //8巡查轨迹
    CruiseTrack: number
    //完成率
    CruiseRate: number
}
export interface CruiseLogFilter {
    Page: number
    PageSize: number
    SortBy: string
    IsAsc: boolean

    DateRange: number
    StartDate: string
    EndDate: string
    UnitLevel: number
    CityId: number
    CountyId: number
    Level: number
    TeamType: number
    Category: number
    Keyword: string
}
//#endregion

export interface CruiseItemData {
    [key: string]: any
    IsEvent: boolean
    Id: number
    UnitName: string
    UnitInfoId?: number
    Comment: string
    CreatedAt: string
    PointName: string
    PointLat?: number
    PointLong?: number
    UserName: string
    UserId: number
    Attachments: Array<{ IsVideo: boolean, Url: string, Id: string }>
    LevelName?: string
    Address?: string
    MonitorAreaPositions?: Array<{ latitude: number, longitude: number }>
    ProtectAreaPositions?: Array<{ latitude: number, longitude: number }>
}

export interface NewCruiseData {
    CruiseType: string
    UnitId: number
    PointId: number
    UnitName: string
    PointName?: string
    Comments: string
    PointLat?: number
    PointLong?: number
    AttachType: number
    AttachGuid: string
    CruiseTime: string
}

// export const getTeamTypes = () => {
//     return tryAxios({
//         method: 'get',
//         url: GetTeamTypes
//     })
// }
// export const getLogLevels = () => {
//     return tryAxios({
//         method: 'get',
//         url: GetLogLevels
//     })
// }
export const getLogList = (param?: any) => {
    return tryAxios({
        method: 'get',
        url: GetLogList,
        params: param
    })
}
export const getLogReport = (param?: any) => {
    return tryAxios({
        method: 'get',
        url: GetLogReport,
        params: param
    })
}
export const getList = (param?: any) => {
    return tryAxios({
        method: 'get',
        url: GetList,
        params: param
    })
}
export const getNew = () => {
    return tryAxios({
        method: 'get',
        url: GetNew
    })
}
export const viewInfo = (id: number) => {
    return tryAxios({
        method: 'get',
        url: View(id)
    })
}
export const removeData = (id: number) => {
    return tryAxios({
        method: 'delete',
        url: Delete(id)
    })
}
export const getUnitPoints = (id: number) => {
    return tryAxios({
        method: 'get',
        url: GetUnitPoints(id),
    })
}

export const postData = (data: NewCruiseData) => {
    return tryAxios({
        method: 'post',
        url: Post,
        data
    })
}

export const exportSummary = (param?: any) => {
    return tryAxios({
        method: 'get',
        url: ExportSummary,
        params: param
    })
}